export default __webpack_public_path__ + "static/media/engrenagem.d506ccf2.png";